import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import pedidos from './slices/pedidos'
import mensagens from './slices/mensagens'
import insurance from './slices/insurance';
import tabSelector from './slices/tabSelector';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const rootReducer = combineReducers({
  mensagens: mensagens,
  pedidos: pedidos,
  insurance: insurance,
  tabSelector: tabSelector
});

export { rootPersistConfig, rootReducer };
